<template>
  <v-sheet class="position-relative hero-section" color="grey lighten-2">
    <LoadingWidget v-if="loading" />

    <template v-else>
      <Video v-if="video.desktop" />

      <SlideShow v-else-if="slides.length"></SlideShow>
    </template>
  </v-sheet>
</template>

<script>
import LoadingWidget from "../../widgets/LoadingWidget.vue";
import Video from "./Video.vue";
import SlideShow from "./SlideShow.vue";

const _data = {
  loading: true,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    video() {
      return this.$rest("video-top").item;
    },
    slides() {
      return this.$rest("slides").list.filter(({ desktop }) => !!desktop);
    },
  },
  created() {
    const video = this.$rest("video-top").get({
      save: (state, data) => (state.item = data),
    });

    const slides = this.$rest("slides").get();

    Promise.all([video, slides]).finally(() => (this.loading = false));
  },
  components: {
    LoadingWidget,
    Video,
    SlideShow,
  },
};
</script>

<style lang="scss" scoped>
.hero-section {
  &:after {
    background: rgb(0, 94, 58);
    background: -moz-linear-gradient(
      0deg,
      rgba(0, 94, 58, 1) 0%,
      rgba(0, 0, 0, 0) 43%
    );
    background: -webkit-linear-gradient(
      0deg,
      rgba(0, 94, 58, 1) 0%,
      rgba(0, 0, 0, 0) 43%
    );
    background: linear-gradient(
      0deg,
      rgba(0, 94, 58, 1) 0%,
      rgba(0, 0, 0, 0) 43%
    );
    bottom: 0;
    content: "";
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#005e3a",endColorstr="#000000",GradientType=1);
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
